import React, { useState, useEffect, forwardRef } from 'react';
import { Button, Form, FormControl, Container, Row, Col, Tabs, Tab, ButtonToolbar, Dropdown } from 'react-bootstrap';
import { Link, useHistory, useLocation } from "react-router-dom";
import MaterialTable from '@material-table/core'
import { Paper } from '@mui/material'
import { Chip, Avatar, IconButton } from '@mui/material';
import {
    FirstPage,
    LastPage,
    ChevronLeft,
    ChevronRight,
    Clear,
    Search,
    ArrowDownward,
} from '@mui/icons-material'
import { grey } from '@mui/material/colors'
import httpClient from "utility/httpClient.util"
import DropdownMenus from 'components/DropdownMenus'
import "./navsearch.scss"

const tableIcons = {
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
}

const columns = [
    { field: "id", title: "ID", width: 0 },
    { field: "hn", title: "HN", width: 100 },
    { field: "name", title: "Name", width: 100 },
    { field: "version", title: "Age", width: 20 },
    { field: "buildVersion", title: "Parent Name", width: 20 },
    { field: "now", title: "Remark", width: 20 },
];


const columnsWard = [
    { field: "id", title: "ID", width: 0 },
    { field: "bedCode", title: "Bed", width: 20 },
    { field: "hn", title: "HN", width: 100 },
    { field: "an", title: "AN", width: 100 },
    { field: "patientName", title: "Name", width: 100 },
    { field: "checkInDate", title: "Admit Date", width: 100 }
];
const data = [

]

const filter = [{ value: 'hn', label: 'HN', isSelected: true }, { value: 'firstName', label: 'ชื่อ', isSelected: true }, { value: 'lastName', label: 'นามสกุล', isSelected: true }, { value: 'parentName', label: 'ชื่อบิดา-มารดา' }, { value: 'address', label: 'ที่อยู่' }]


const NavSearch = () => {
    const history = useHistory()
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenWard, setIsOpenWard] = useState(false);
    const [isMore, setIsMore] = useState(false);
    const [isResult, setIsResult] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState('')
    const [data, setData] = useState([])
    const [currentTab, setCurrentTab] = useState('patient')
    const [filterState, setFilterState] = useState(filter.map((item) => {
        return { isSelected: false, ...item }
    }))
    const [activeWard, setActiveWard] = useState('')
    const [activeRoom, setActiveRoom] = useState('')
    const [wardOptions, setWardOptions] = useState([])
    const [roomOptions, setRoomOptions] = useState([])
    const [page, setPage] = useState(0); // Current page of the table
    const pageSize = 10;
    const queryParams = new URLSearchParams(history.location.search)
    const an = queryParams.get('an')


    const onToggleSelectFilter = (item, index) => {
        filterState[index].isSelected = filterState[index].isSelected ? !filterState[index].isSelected : true;
        setFilterState([].concat(filterState))
    }

    const getWard = async () => {
        setIsLoading(true)
        const [wards, admitInfo] = await Promise.all([
            httpClient.get(`/core/ward`).then(({ data }) => data.data),
            httpClient.get(`/ipd/in-patient-admit/profile?an=${an}&include=Ward,room`).then(({ data }) => data.data),
        ]);

        if (wards) {
            setWardOptions(wards)
            if (admitInfo) {
                setActiveWard(
                    wards
                        .map(item => ({ ...item, id: item.wardCode, title: item.wardCode + " - " + item.name }))
                        .find(({ wardCode }) => wardCode === admitInfo.wardCode) || null
                );
                if (admitInfo?.wardCode)
                    await loadRoomInWard(admitInfo?.wardCode, admitInfo?.roomNumber)
            } else {
                setActiveWard(null);
            }
        } else {
            setWardOptions([])
        }
        setIsLoading(false)
    }



    const loadRoomInWard = async (wardCode, roomNumber = null) => {
        try {
            // Fetch room data
            const room = roomOptions.find((item) => item?.wardCode === wardCode)

            const roomPromise = !room ? httpClient
                .get(`/core/room/search?page=1&perPage=1000&searchKey=${wardCode}`)
                .then(({ data }) => data.data || [])
                : Promise.resolve([])

            // Fetch patient dashboard data if roomNumber is provided
            const patientDashboardPromise = roomNumber
                ? httpClient
                    .get(
                        `/ipd/in-patient-admit/patient-dashboard?ward=${wardCode}&page=1&perPage=1000&room=${roomNumber}`
                    )
                    .then(({ data }) => data.data)
                : Promise.resolve([]); // Return empty array if roomNumber is null

            // Wait for both promises to resolve
            const [rooms, patientDashboardData] = await Promise.all([roomPromise, patientDashboardPromise]);

            // Update room options
            setRoomOptions(rooms);

            if (roomNumber) {
                // Find active room
                const activeRoom = rooms.find(room => room.roomNumber === roomNumber);
                
                if (activeRoom) {
                    setActiveRoom({...activeRoom,id:activeRoom.roomNumber,title:activeRoom.roomNumber+ " - " + activeRoom.name});
                }

            }
            // Process patient dashboard data
            const processedData = patientDashboardData
                .filter(row => row?.an) // Only include rows with an `an` value
                .map((row, index) => ({
                    ...row,
                    id: index + 1, // Assign running number starting from 1
                }));

            setData(processedData);

            const resultIndex = processedData.findIndex(row => row?.an === an);

            // Calculate the page where the result row is located
            const resultPage = resultIndex >= 0 ? Math.floor(resultIndex / pageSize) : 0;
            setPage(resultPage)
        } catch (error) {
            console.error('Error loading room or patient data:', error);
            // Handle the error (e.g., show a notification to the user)
        }
    };



    const loadPatientInWard = async (wardCode) => {

        const resp = (await httpClient.get(`/ipd/in-patient-movement/getBed?filterCode=${wardCode}&filterType=ward`).then(({ data }) => data.data)) || []

        setRoomOptions(resp.length > 0 ? resp[0].rooms : [])

        if (resp.length > 0 && resp[0].rooms.length === 1) {
            const room = { ...resp[0].rooms[0], title: resp[0].rooms[0].roomNumber + " - " + resp[0].rooms[0].name }
            setActiveRoom(room);
            await loadPatientInRoom(room)
        } else {
            // /ipd/in-patient-admit/patient-dashboard?ward=01&page=1&perPage=20&room=10
        }

    }

    const loadPatientInRoom = async (room) => {

        setData(room.beds.filter((row) => row?.an).map((row, index) => ({
            ...row,
            id: index + 1, // Assign running number starting from 1
        })))
        // Find the index of the row matching the resultAn
        const resultIndex = room.beds.findIndex(row => row?.an === an);

        // Calculate the page where the result row is located
        const resultPage = resultIndex >= 0 ? Math.floor(resultIndex / pageSize) : 0;
        setPage(resultPage)
    }

    useEffect(async () => {
        if (isOpenWard && an)
            await getWard()
    }, [isOpenWard, an])

    const renderFilter = () => {
        return (
            <div className="container-filter">
                <Container>
                    <Form.Group as={Row} >
                        <div style={{ lineHeight: '32px' }}>Search for : </div>
                        {filterState.map((item, index) => (
                            <div onClick={() => onToggleSelectFilter(item, index)}>
                                <Chip
                                    className='m-l-5'
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                    avatar={
                                        <Avatar >
                                            {item.isSelected ? (<i className={'fas fa-check'} ></i>) : '#'}
                                        </Avatar>
                                    }
                                    label={item.label}
                                    color={item.isSelected ? 'primary' : 'default'}

                                />
                            </div>
                        ))}
                    </Form.Group>
                </Container>
            </div>
        )
    }

    const renderFilterWard = () => {
        return (
            <div className="container-filter">
                <Container>
                    <Form.Group as={Row} >
                        <div style={{ lineHeight: '48px' }} className='mr-1'>Search Ward : </div>
                        <ButtonToolbar>
                            <DropdownMenus
                                menuList={wardOptions.map((item) => { return { ...item, id: item.wardCode, title: item.wardCode + " - " + item.name } })}
                                onSelect={(item) => { setActiveWard(item); loadRoomInWard(item.wardCode) }}
                                value={activeWard}
                                renderToggle={() => (<span><i className='fas fa-building mr-1' />{activeWard ? activeWard.title : 'Select Ward...'} <i className='fas fa-caret-down ml-1 f-18'></i></span>)}
                            />
                            {activeWard && (
                                <>
                                    <div style={{ lineHeight: '48px' }} className='ml-5 mr-1'>Room : </div>
                                    <DropdownMenus
                                        menuList={roomOptions.map((item) => { return { ...item, id: item.roomNumber, title: item.roomNumber + " - " + item.name } })}
                                        onSelect={(item) => { setActiveRoom(item); loadRoomInWard(activeWard.wardCode, item.roomNumber) }}
                                        renderToggle={() => (<span><i className='fas fa-building mr-1' />{activeRoom ? activeRoom.title : 'Select Room...'} <i className='fas fa-caret-down ml-1 f-18'></i></span>)}
                                    />
                                </>
                            )}
                        </ButtonToolbar>
                    </Form.Group>
                </Container>
            </div>
        )
    }

    const recentSearch = () => {

    }

    const renderMoreFilter = () => {
        return (
            <div className="container-filter">
                <Container>
                    <Form.Group as={Row} style={{ width: 500 }}>
                        <Col sm={4}>
                            <Form.Check
                                custom
                                type="radio"
                                label="HN"
                                name="formHorizontalRadios"
                                id="hn"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="VN"
                                name="formHorizontalRadios"
                                id="vn"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="AN"
                                name="formHorizontalRadios"
                                id="an"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="ID Card"
                                name="formHorizontalRadios"
                                id="idCard"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="SSN"
                                name="formHorizontalRadios"
                                id="ssn"
                            />

                        </Col>
                        <Col sm={4}>
                            <Form.Check
                                custom
                                type="radio"
                                label="First Name"
                                name="formHorizontalRadios"
                                id="firstName"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="Last Name"
                                name="formHorizontalRadios"
                                id="lastName"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="First + Last"
                                name="formHorizontalRadios"
                                id="firstLastName"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="Finger Scan"
                                name="formHorizontalRadios"
                                id="finger"
                            />


                        </Col>
                        <Col sm={4}>
                            <Form.Check
                                custom
                                type="radio"
                                label="Parent Name"
                                name="formHorizontalRadios"
                                id="fatherMotherName"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="Contact Name"
                                name="formHorizontalRadios"
                                id="contactName"
                            />
                            <Form.Check
                                custom
                                type="radio"
                                label="Patient Address"
                                name="formHorizontalRadios"
                                id="patientAddress"
                            />

                        </Col>
                    </Form.Group>
                </Container>
            </div>
        )
    }



    const onRowClick = (e, row) => {
        console.log("click", row)
        setIsOpen(false);
        ///#/patient-file/pas/display/form/patient-register?hn=990008256&an=991124171144&vn=991124171138
        if (currentTab === 'patient') {
            history.push(`/patient-file/pas/display/form/patient-register?hn=${row.hn}`)
        } else if (currentTab === 'visit') {
            history.push(`/patient-file/opd/display/form/form-screening?hn=${row.hn}&an=${row.an}&vn=${row.vn}`)
        } else if (currentTab === 'admit') {
            history.push(`/patient-file/ipd/display/form/form-admission-note?hn=${row.hn}&an=${row.an}&vn=${row.vn}`)
        }
    }

    const onRowWardClick = (e, row) => {
        setIsOpenWard(false);
        const currentParams = new URLSearchParams(location.search);
        currentParams.set('hn', row.hn);
        currentParams.set('an', row.an);
        currentParams.set('vn', row.vn);

        // const newUrl = `${location.pathname}?${currentParams.toString()}`;
        // history.push(newUrl);

        const baseUrl = window.location.href.split('#')[0];
        const [hashPath, existingSearchParams] = window.location.hash.split('?');
        let newHashPath = hashPath


        const newHash = `${newHashPath}?${currentParams.toString()}`;
        const newUrl = `${baseUrl}${newHash}`;
        //console.log('new',newHash,newUrl)
        history.push({
            search: `?${currentParams.toString()}` // should be a query string starting with `?`
        });

    }


    const getLinkUrl = (item) => {


        // Create a URLSearchParams object from the existing parameters
        const newParams = new URLSearchParams(existingSearchParams);

        // Construct new query parameters
        //const newParams = new URLSearchParams();
        if (item.an) newParams.set('an', item.an);
        if (item.hn) newParams.set('hn', item.hn);
        if (item.vn) newParams.set('vn', item.vn);
        if (item.an === item.activeAn)
            newParams.delete('readonly')
        else
            newParams.set('readonly', 'true')


        // Construct the new hash portion of the URL
        const baseUrl = window.location.href.split('#')[0];
        const [hashPath, existingSearchParams] = window.location.hash.split('?');
        let newHashPath = hashPath


        const newHash = `${newHashPath}?${newParams.toString()}`;
        const newUrl = `${baseUrl}${newHash}`;
        //console.log('new',newHash,newUrl)
        history.push({
            search: `?${newParams.toString()}` // should be a query string starting with `?`
        });
        return newUrl
    }


    const renderTabResult = () => {
        return (
            <Row>
                <Col sm={12}><div>{isResult ? 'Search Result' : 'Recent Search'}</div></Col>
                <Col md={12} className='search-result'>
                    <Tabs
                        activeKey={currentTab}
                        defaultActiveKey="patient"
                        className="mb-3"
                        onSelect={(tab) => {
                            setCurrentTab(tab)
                        }}
                    >
                        <Tab eventKey="patient" title="Patient">
                            {renderSearchResult()}
                        </Tab>
                        <Tab eventKey="visit" title="Visit">
                            {renderSearchResult()}
                        </Tab>
                        <Tab eventKey="admit" title="Admit">
                            {renderSearchResult()}
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        )
    }

    const renderSearchResult = () => {
        return (
            <Row>
                <Col sm={12} >
                    <MaterialTable
                        title={<div>{isResult ? 'Search Result' : 'Recent Search'}</div>}
                        columns={columns}
                        data={data}
                        isLoading={isLoading}
                        components2={{
                            Container: (props) => <Paper {...props} elevation={0} />,
                        }}
                        components={{
                            Container: (props) => (
                                <Paper {...props} elevation={0} sx={{ display: 'inherit !important' }} />
                            ),
                        }}
                        options={{
                            showTitle: false,
                            search: false,
                            selection: false,
                            toolbar: false,
                            paging: true,

                        }}
                        icons={tableIcons}
                        onRowClick={onRowClick}
                    />
                </Col>
            </Row>
        )
    }

    const highlightRowStyle = row => ({
        backgroundColor: row.an === an ? 'rgba(255, 235, 59, 0.5)' : undefined, // Highlight color
    });

    const renderSearchResultWard = () => {
        return (
            <Row>
                <Col sm={12} >
                    <MaterialTable
                        title={<div>{isResult ? 'Search Result' : 'Recent Search'}</div>}
                        columns={columnsWard}
                        data={data}
                        isLoading={isLoading}
                        components2={{
                            Container: (props) => <Paper {...props} elevation={0} />,
                        }}
                        components={{
                            Container: (props) => (
                                <Paper {...props} elevation={0} sx={{ display: 'inherit !important' }} />
                            ),
                        }}
                        options={{
                            showTitle: false,
                            search: true,
                            selection: false,
                            toolbar: false,
                            paging: true,
                            pageSize,
                            page,
                            rowStyle: rowData => highlightRowStyle(rowData),
                        }}
                        icons={tableIcons}
                        onRowClick={onRowWardClick}
                    />
                </Col>
            </Row>
        )
    }

    const onSearchChange = async (e, q) => {
        console.log('q', q);
        if (q && q.length > 0)
            setIsResult(true)
        else {
            setIsResult(false)
            setData([])
        }
        setSearchText(q)

        if (q && q.length >= 3) {
            setIsLoading(true)
            const result = await httpClient.get(`/pas/patient/search?searchKey=${q}&page=1&perPage=20`).then((response) => {
                return response.data.data
            })
            setIsLoading(false);

            const list = result.map((item, index) => {
                return { id: index + 1, name: item.person.firstName + " " + item.person.lastName, hn: item.hn, "result": "", "version": "0.0.1", "buildVersion": "16082022-1416", "prefix": null, "now": new Date().getTime() }
            })
            setData(list)

        }
    }

    const onSearchWardChange = async (e, q) => {
        console.log('q', q);
        if (q && q.length > 0)
            setIsResult(true)
        else {
            setIsResult(false)
            setData([])
        }
        setSearchText(q)

        if (q && q.length >= 3) {
            setIsLoading(true)
            const result = await httpClient.get(`/ipd/in-patient-admit/patient-dashboard?searchKey=${q}&page=1&perPage=20`).then((response) => {
                return response.data.data
            })
            setIsLoading(false);

            const list = result.map((item, index) => {
                return { id: index + 1, ...item }
            })
            setData(list)

        }
    }


    let searchContent = '';
    if (isOpen) {
        searchContent = (
            <div className={"nav-search search-bar " + (isMore || isResult ? "is-more" : "")}>
                <FormControl type="text" autoFocus className="border-0 shadow-none" placeholder="Search here..." value={searchText} onChange={(e, v) => onSearchChange(e, e.target.value)} />
                <Button variant='link' type="button" className="bar-icon clear-text" aria-label="Close" onClick={(e) => onSearchChange(e, '')}>
                    <span aria-hidden="true"><i className={"fa fa-eraser"} /></span>
                </Button>
                <Button variant='link' type="button" className="bar-icon more-filter" aria-label="Close" onClick={() => setIsMore(!isMore)}>
                    <span aria-hidden="true"><i className={"feather " + (isMore ? "icon-chevron-down" : "icon-chevron-left")} /></span>
                </Button>
                <Button variant='link' type="button" className="close" aria-label="Close" onClick={() => setIsOpen(false)}>
                    <span aria-hidden="true"><i className="feather icon-x" /></span>
                </Button>
                {renderFilter()}
                {
                    isMore && renderMoreFilter()
                }
                {
                    renderTabResult()
                }
            </div>
        );
    }

    if (isOpenWard) {
        searchContent = (
            <div className={"nav-search search-bar " + (isMore || isResult ? "is-more" : "")}>
                <FormControl type="text" autoFocus className="border-0 shadow-none" placeholder="Search here..." value={searchText} onChange={(e, v) => onSearchWardChange(e, e.target.value)} />
                <Button variant='link' type="button" className="bar-icon clear-text" aria-label="Close" onClick={(e) => onSearchWardChange(e, '')}>
                    <span aria-hidden="true"><i className={"fa fa-eraser"} /></span>
                </Button>
                {/* <Button variant='link' type="button" className="bar-icon more-filter" aria-label="Close" onClick={() => setIsMore(!isMore)}>
                    <span aria-hidden="true"><i className={"feather " + (isMore ? "icon-chevron-down" : "icon-chevron-left")} /></span>
                </Button> */}
                <Button variant='link' type="button" className="close" aria-label="Close" onClick={() => setIsOpenWard(false)}>
                    <span aria-hidden="true"><i className="feather icon-x" /></span>
                </Button>
                {renderFilterWard()}
                {
                    isMore && renderMoreFilter()
                }
                {
                    renderSearchResultWard()
                }
            </div>
        );
    }



    return (
        <React.Fragment>
            <Link to='#' className="pop-search" onClick={(e) => { e.preventDefault(); setIsOpen(true); }}><i className="feather icon-search" /></Link>
            {an && (<Link to='#' className="pop-search ml-1" onClick={(e) => { e.preventDefault(); setIsOpenWard(true); }}>AN : {an}<i class="fas fa-caret-down m-l-5"></i></Link>)}
            {searchContent}
        </React.Fragment>
    );
};

export default NavSearch;
